import { POLICY_BLOCKS } from "@/lib/mockData";
import SectionHeading from "@/components/SectionHeading";
import SectionReveal from "@/components/SectionReveal";
import OrganicShapes from "@/components/OrganicShapes";

export default function Terms() {
    return (
        <main data-testid="terms-page" className="bg-white pt-32 pb-24 relative overflow-hidden">
            <OrganicShapes variant="beige" />
            <section className="max-w-4xl mx-auto px-6 md:px-10 relative">
                <SectionHeading
                    eyebrow="Terms & Conditions"
                    heading={["Plain terms for", "using Seedh."]}
                    italicIndex={1}
                    description="A simple, honest set of rules covering public records, donations, replacements, and acceptable use of our tracker."
                />

                <div className="mt-16 space-y-8">
                    {POLICY_BLOCKS.terms.map((b, i) => (
                        <SectionReveal delay={i * 0.05} key={b.heading}>
                            <article className="card-base bg-seedh-surface-blue/40 p-7" data-testid={`terms-block-${i}`}>
                                <div className="text-[0.65rem] tracking-[0.24em] uppercase text-seedh-brown font-semibold">
                                    Clause {String(i + 1).padStart(2, "0")}
                                </div>
                                <h2 className="font-display text-2xl text-seedh-blue mt-2 leading-tight">
                                    {b.heading}
                                </h2>
                                <p className="text-base text-seedh-text mt-3 leading-relaxed">
                                    {b.body}
                                </p>
                            </article>
                        </SectionReveal>
                    ))}
                </div>

                <SectionReveal delay={0.2}>
                    <p className="mt-12 text-xs text-seedh-muted leading-relaxed">
                        Last updated · February 2026 · Placeholder content. Final
                        terms can be added before production launch.
                    </p>
                </SectionReveal>
            </section>
        </main>
    );
}
